<template>
  <div>
    <h2>{{ data.title }}</h2>
    <div class="notice">
      <p
        v-for="(paragraph, index) in data.paragraphs"
        :key="index"
        v-html="paragraph"
      ></p>
    </div>
    <fee-free-days-display :freeDays="freeDays" />
  </div>
</template>

<script>
import FeeFreeDaysDisplay from "@/components/Passes/FeeFreeDaysDisplay.vue";
export default {
  name: "KnowBeforeYouGo",
  components: {
    FeeFreeDaysDisplay
  },

  props: ["data", "freeDays"]
};
</script>
